import { supabase } from "../Db_Connections/db_connection"; // Path check kar lena

// READ ALL (Admin ke liye - With Name)
export async function getAttendance() {
  const { data, error } = await supabase
    .from("attendance")
    .select(`
      *,
      profiles:profile_id (first_name, last_name, designation)
    `)
    .order("attendance_date", { ascending: false });

  return { data, error };
}

// READ BY PROFILE (User ke liye)
export async function getAttendanceByProfile(profile_id) {
  const { data, error } = await supabase
    .from("attendance")
    .select("*")
    .eq("profile_id", profile_id)
    .order("attendance_date", { ascending: false });

  return { data, error };
}

// CHECK TODAY'S STATUS (Ye check karega ki aaj user ne check-in kiya hai ya nahi)
export async function getTodayAttendance(profile_id) {
  const today = new Date().toISOString().split('T')[0]; // YYYY-MM-DD
  const { data, error } = await supabase
    .from("attendance")
    .select("*")
    .eq("profile_id", profile_id)
    .eq("attendance_date", today)
    .single();

  return { data, error };
}

// CHECK-IN FUNCTION (Create New Row)
export async function checkInUser(profile_id) {
  const now = new Date();
  const todayDate = now.toISOString().split('T')[0];
  const checkInTime = now.toISOString(); // Full timestamp

  const { data, error } = await supabase
    .from("attendance")
    .insert([
      {
        profile_id: profile_id,
        attendance_date: todayDate,
        check_in_time: checkInTime,
        status: 'Present',
        working_hours: 0
      },
    ])
    .select()
    .single();

  return { data, error };
}

// CHECK-OUT FUNCTION (Update Existing Row)
export async function checkOutUser(attendance_id) {
  const now = new Date();
  const checkOutTime = now.toISOString();

  // Pehle check-in time fetch karte hain calculation ke liye
  const { data: record, error: fetchError } = await supabase
    .from("attendance")
    .select("check_in_time")
    .eq("id", attendance_id)
    .single();

  if (fetchError) return { error: fetchError };

  // Calculate Working Hours
  const startTime = new Date(record.check_in_time);
  const endTime = new Date(checkOutTime);
  const diffMs = endTime - startTime;
  const totalHours = (diffMs / (1000 * 60 * 60)).toFixed(2); // e.g., 8.5 hours

  const { data, error } = await supabase
    .from("attendance")
    .update({
      check_out_time: checkOutTime,
      working_hours: totalHours
    })
    .eq("id", attendance_id)
    .select()
    .single();

  return { data, error };
}
export async function autoClosePastSessions(profile_id) {
  const today = new Date().toISOString().split('T')[0]; // YYYY-MM-DD

  // 1. Aisi rows dhundo jo 'Pending' hain aur Aaj ki date se purani hain
  const { data: openSessions, error } = await supabase
    .from('attendance')
    .select('*')
    .eq('profile_id', profile_id)
    .is('check_out_time', null) // Checkout nahi hua
    .lt('attendance_date', today); // Date < Today

  if (error || !openSessions || openSessions.length === 0) {
    return false; // Kuch update nahi kiya
  }

  // 2. Un sabhi sessions ko update karo
  for (const session of openSessions) {
    const checkInTime = new Date(session.check_in_time);

    // Logic: Check-in time + 3 Hours
    const autoCheckOutTime = new Date(checkInTime.getTime() + (3 * 60 * 60 * 1000));

    await supabase
      .from('attendance')
      .update({
        check_out_time: autoCheckOutTime.toISOString(),
        working_hours: 3.00, // Fixed 3 hours
        remarks: 'System: Forgot Checkout (Auto-closed)',
        status: 'Half Day' // Optional: Status change kar sakte hain
      })
      .eq('id', session.id);
  }

  return true; // True matlab correction hua hai
}
